var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.9C10 1.13029 9.93025 1.36069 9.79074 1.53619L4.07645 8.73619C3.9375 8.91281 3.75446 9 3.57143 9C3.38839 9 3.2058 8.91211 3.06652 8.73633L0.209375 5.13633C0.0698661 4.96125 0 4.73063 0 4.5C0 3.98588 0.333705 3.6 0.714286 3.6C0.897054 3.6 1.07991 3.68789 1.2192 3.86367L3.57143 6.82875L8.78125 0.264375C8.91964 0.0880313 9.10268 0 9.28571 0C9.66741 0 10 0.385313 10 0.9Z",
    fill: "#10A37F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenIcon);
export default __webpack_public_path__ + "static/media/checkGreenIcon.ee34ade514a0cff8a498c9d3215bba04.svg";
export { ForwardRef as ReactComponent };